































































































































































































































































































































































































































































import _ from "lodash";
import {computed, onBeforeMount, ref} from "@vue/composition-api";
import Vue from "vue";
import MessageEditor from "../../components/MessageEditor";
import {
  abandonedCheckoutOptions,
  reactivationOptions,
  shippingOptions
} from "../../helpers/consts";
import appBridge from "../../helpers/appBridge";

export default Vue.extend({
  name: "Automations",
  components: {
    MessageEditor
  },
  setup(props, context: any): any {
    const messageEditorModal = ref(false);
    const deleteAutomationModal = ref(false);
    const selectedDeleteAutomation = ref(null);
    const message = ref("");
    const discount = ref({});
    const selectedAutomation = ref({
      name: "",
      body: "",
      discount: {},
      enabled: false,
      delay: "",
      trigger: ""
    });
    const validForm = ref(false);
    const checkoutUpdating = ref(false);
    const reactivationUpdating = ref(false);
    const shippingUpdating = ref(false);

    onBeforeMount(() => {
      context.root.$mixpanel.track("Page Load", {Page: "Automations"});
      context.root.$store.dispatch("shop/getShippingCountries");
      context.root.$store.dispatch("shop/getExistingDiscounts");
      context.root.$store.dispatch("automations/getAutomations");
    });

    const recovery = computed(() => {
      const arr = [];
      context.root.$store.state.automations.automations.automations.forEach(
        el => {
          //
          if (el.trigger === "ABANDONED_CHECKOUT") {
            arr.push(el);
          }
        }
      );

      return arr;
    });
    const reactivation = computed(() => {
      const arr = [];
      context.root.$store.state.automations.automations.automations.forEach(
        el => {
          //
          if (el.trigger === "CUSTOMER_REACTIVATION") {
            arr.push(el);
          }
        }
      );

      return arr;
    });
    const shipping = computed(() => {
      const arr = [];
      context.root.$store.state.automations.automations.automations.forEach(
        el => {
          //
          if (el.trigger === "SHIPPING_CONFIRMATION") {
            arr.push(el);
          }
        }
      );

      return arr;
    });

    function getAutomations() {
      context.root.$store.dispatch("automations/getAutomations");
    }

    function handleOpenMessageEditor(automation) {
      messageEditorModal.value = true;
      selectedAutomation.value = _.cloneDeep(automation);
      message.value = automation.body;
      discount.value = automation.discount;
    }

    function handleUpdateMessageEditor({val, formValid, discount}) {
      // @ts-ignore
      selectedAutomation.value.body = val;
      // @ts-ignore
      selectedAutomation.value.discount = discount;
      validForm.value = formValid;
    }

    function handleAddNewAutomation(trigger) {
      const payload = {
        body:
          "{ShopName}: Hi {FirstName}, we noticed there were some items left in your shopping cart. If you're ready to complete your order, we saved your cart here {CheckoutUrl}",
        delay: "600s",
        discount: null,
        enabled: false,
        trigger
      };

      if (trigger === "ABANDONED_CHECKOUT") {
        checkoutUpdating.value = true;
      }
      if (trigger === "CUSTOMER_REACTIVATION") {
        reactivationUpdating.value = true;
        payload.delay = "2628000s";
        payload.body =
          "{ShopName}: Hi {FirstName}, it has been a while since we have seen you! Check out our range of products at {ShopUrl}";
      }
      if (trigger === "SHIPPING_CONFIRMATION") {
        shippingUpdating.value = true;
        payload.delay = "86400s";
        payload.body =
          "Hi {FirstName}, great news! Your order from {ShopName} has been shipped with {ShippingCompany}. 📦😍";
      }

      context.root.$store
        .dispatch("automations/createAutomation", payload)
        .then(res => {
          context.root.$store.commit(
            "setSuccess",
            {data: "Automation created"},
            {root: true}
          );
          context.root.$mixpanel.track("Entity Create", {
            Page: "Automations",
            type: res.trigger
          });
          checkoutUpdating.value = false;
          reactivationUpdating.value = false;
          shippingUpdating.value = false;
          getAutomations();
        });
    }
    function handleUpdateAutomation(val, field) {
      let payload = {};

      if (field === "body") {
        if (selectedAutomation.value.trigger === "ABANDONED_CHECKOUT") {
          checkoutUpdating.value = true;
        }
        if (selectedAutomation.value.trigger === "CUSTOMER_REACTIVATION") {
          reactivationUpdating.value = true;
        }
        if (selectedAutomation.value.trigger === "SHIPPING_CONFIRMATION") {
          shippingUpdating.value = true;
        }

        payload = {
          name: selectedAutomation.value.name,
          payload: {
            body: selectedAutomation.value.body,
            discount: selectedAutomation.value.discount,
            enabled: selectedAutomation.value.enabled,
            delay: selectedAutomation.value.delay,
            trigger: selectedAutomation.value.trigger
          }
        };
      } else {
        if (val.trigger === "ABANDONED_CHECKOUT") {
          checkoutUpdating.value = true;
        }
        if (val.trigger === "CUSTOMER_REACTIVATION") {
          reactivationUpdating.value = true;
        }
        if (val.trigger === "SHIPPING_CONFIRMATION") {
          shippingUpdating.value = true;
        }

        payload = {
          name: val.name,
          payload: {
            body: val.body,
            discount: val.discount,
            enabled: val.enabled,
            delay: val.delay,
            trigger: val.trigger
          }
        };
      }

      context.root.$store
        .dispatch("automations/updateAutomation", payload)
        .then(res => {

          context.root.$store.commit(
            "setSuccess",
            {data: "Automation updated"},
            {root: true}
          );
          context.root.$mixpanel.track("Entity Update", {
            Page: "Automations",
            type: res.trigger
          });
          checkoutUpdating.value = false;
          reactivationUpdating.value = false;
          shippingUpdating.value = false;
          messageEditorModal.value = false;
          getAutomations();
        });
    }

    function handleDeleteAutomation(val) {
      deleteAutomationModal.value = true;
      selectedDeleteAutomation.value = val;
    }

    function handleConfirmDeleteAutomation() {
      if (selectedDeleteAutomation.value.trigger === "ABANDONED_CHECKOUT") {
        checkoutUpdating.value = true;
      }
      if (selectedDeleteAutomation.value.trigger === "CUSTOMER_REACTIVATION") {
        reactivationUpdating.value = true;
      }
      if (selectedDeleteAutomation.value.trigger === "SHIPPING_CONFIRMATION") {
        shippingUpdating.value = true;
      }

      context.root.$store
        .dispatch("automations/deleteAutomation", {
          name: selectedDeleteAutomation.value.name
        })
        .then(res => {
          context.root.$mixpanel.track("Entity Delete", {
            Page: "Automations",
            type: res.trigger
          });
          checkoutUpdating.value = false;
          reactivationUpdating.value = false;
          shippingUpdating.value = false;
          getAutomations();
          deleteAutomationModal.value = false;
          selectedDeleteAutomation.value = null;
        });
    }

    const loading = computed(() => context.root.$store.state.loading);
    function redirectTo(link) {
      appBridge(context.root.$store.state.store).redirectToRemote(link);
    }

    return {
      redirectTo,
      loading,
      validForm,
      deleteAutomationModal,
      handleUpdateMessageEditor,
      handleConfirmDeleteAutomation,
      handleDeleteAutomation,
      handleUpdateAutomation,
      handleOpenMessageEditor,
      recovery,
      reactivation,
      shipping,
      abandonedCheckoutOptions,
      reactivationOptions,
      shippingOptions,
      messageEditorModal,
      message,
      discount,
      handleAddNewAutomation,
      checkoutUpdating,
      reactivationUpdating,
      shippingUpdating
    };
  }
});
